/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".banner-image[_ngcontent-%COMP%]{width:100%;height:190px;background-color:#dbdbdb;background-position:center;background-repeat:no-repeat;background-size:cover;border-radius:6px;box-shadow:0 4px 30px -10px rgba(0,0,0,.2);margin-bottom:1rem}.week-flights-body.modal__body[_ngcontent-%COMP%]{background-color:#f5f5f5}"];
export { styles as styles };
